import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import { createErrorHandler, ErrorHandlerOptions, SentryErrorHandler } from '@sentry/angular';
import { CustomErrorHandler } from './custom-error-handler.service';

@Injectable()
export class CombinedErrorHandlerService implements ErrorHandler {
  private readonly injector = inject(Injector);

  private sentryErrorHandler: SentryErrorHandler;
  private customErrorHandler: CustomErrorHandler;

  constructor() {
    this.customErrorHandler = this.injector.get(CustomErrorHandler);

    const config: ErrorHandlerOptions = {
      logErrors: true,
      showDialog: false,
    };
    this.sentryErrorHandler = createErrorHandler(config);
  }

  public async handleError(error: any): Promise<void> {
    await this.customErrorHandler.handleError(error);

    if (this.customErrorHandler.isReloadingAfterChunkLoadError) {
      return;
    }

    this.sentryErrorHandler.handleError('Sentry: ' + error);
  }
}
